import React from 'react'

import CtaModule from '@/modules/ctaModule.js'
import BrandTicker from '@/modules/brandTicker.js'
import WhatIs from '@/modules/whatIs.js'
import ExperienceModule from '@/modules/experienceModule.js'
import ImageText from '@/modules/imageText.js'
import Perks from '@/modules/perks.js'
import AboutFounder from '@/modules/aboutFounder.js'
import BlockCta from '@/modules/blockCta.js'
import TeamMembers from '@/modules/teamMembers.js'
import TeamPhoto from '@/modules/teamPhoto.js'
import PressModule from '@/modules/pressModule.js'
import PressGrid from '@/modules/pressGrid.js'

class Modules extends React.Component {
  render() {
    const { module, type } = this.props
    switch (type) {
      case 'blockCta':
        return <BlockCta content={module} />
      case 'whatIs':
        return <WhatIs content={module} />
      case 'imageText':
        return <ImageText content={module} />
      case 'aboutFounder':
        return <AboutFounder content={module} />
      case 'experienceModule':
        return <ExperienceModule content={module} />
      case 'brandTicker':
        return <BrandTicker content={module} />
      case 'perks':
        return <Perks content={module} />
      case 'ctaModule':
        return <CtaModule content={module} />
      case 'teamMembers':
        return <TeamMembers content={module} />
      case 'teamPhoto':
        return <TeamPhoto content={module} />
      case 'pressModule':
        return <PressModule content={module} />
      case 'pressGrid':
        return <PressGrid content={module} />
      default:
        return (<div className='h1 p1'>{type}</div>)
    }
  }
}

export default Modules
